import React from "react";

import { useLoadServiceProcesses } from "Reducers/serviceProcesses/hooks/useLoadServiceProcesses";

import { ProcessesHeader } from "./ProcessList/components/ProcessesHeader";
import { ProcessList } from "./ProcessList/ProcessList";
import * as S from "./ServiceProcessesPage.styles";

const ServiceProcessesPage = () => {
  useLoadServiceProcesses();

  return (
    <S.ServiceProcessesPageRoot>
      <ProcessesHeader />

      <ProcessList />
    </S.ServiceProcessesPageRoot>
  );
};

export default ServiceProcessesPage;
